export default "__VITE_ASSET__d04e8df9__"